import { Capacitor } from '@capacitor/core'

/** True when running inside the iOS/Android shell rather than a browser. */
export const isNativeApp = Capacitor.isNativePlatform()

/** 'ios' | 'android' | 'web' */
export const platform = Capacitor.getPlatform()
